import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { changeConfigDataValue, changeFlexibleSpecValue } from 'redux/modules/audience';
import { clearInterestData, queryInterests } from 'redux/modules/audienceInterests';
import * as _ from 'lodash';
import AutoComplete from 'material-ui/AutoComplete';
import { Tooltip } from 'components';
var AudienceInterests = (_dec = connect(function (state) {
  return {
    dataSource: state.audienceInterests.dataSource,
    exclusions: state.audience.FacebookTargetingConfig.data.exclusions,
    organization: state.organization.current
  };
}, {
  changeConfigDataValue: changeConfigDataValue,
  changeFlexibleSpecValue: changeFlexibleSpecValue,
  clearInterestData: clearInterestData,
  queryInterests: queryInterests
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(AudienceInterests, _Component);

  var _super = _createSuper(AudienceInterests);

  function AudienceInterests(props) {
    var _this;

    _classCallCheck(this, AudienceInterests);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleAutoCompleteValueSelected", function (v) {
      v.type = 'interests';

      _this.props.changeFlexibleSpecValue(_this.props.specIndex, v);

      _this.setState({
        searchText: ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleExclusionValueSelected", function (v) {
      var updatedExclusions = Object.assign({}, _this.props.exclusions);
      var strippedNewValue = {
        id: v.id,
        name: v.name
      }; //    updatedExclusions.interests = _.unionBy(updatedExclusions.interests, [strippedNewValue], 'id');

      updatedExclusions.interests = [].concat(_toConsumableArray(updatedExclusions.interests), [strippedNewValue]);

      _this.props.changeConfigDataValue('exclusions', updatedExclusions);

      _this.setState({
        searchText: ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleAutoCompleteUpdate", _.debounce(function (query) {
      if (query) {
        _this.props.queryInterests(query);
      }
    }, 200));

    _this.state = {
      searchText: ''
    };
    return _this;
  }

  _createClass(AudienceInterests, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.clearInterestData();
    }
    /** *********************************************************
     EVENT HANDLERS
     ***********************************************************/

  }, {
    key: "render",
    value:
    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      var _this2 = this;

      var isExclusion = this.props.isExclusion;
      return /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-3",
        style: {
          lineHeight: '46px',
          color: '#616161'
        }
      }, "Interests"), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-8"
      }, /*#__PURE__*/React.createElement(AutoComplete, {
        fullWidth: true,
        searchText: this.state.searchText,
        hintText: "Search for interests",
        onUpdateInput: function onUpdateInput(searchText) {
          _this2.setState({
            searchText: searchText
          });

          _this2.handleAutoCompleteUpdate(searchText);
        },
        onNewRequest: function onNewRequest(v) {
          _this2.props.isExclusion ? _this2.handleExclusionValueSelected(v) : _this2.handleAutoCompleteValueSelected(v);
        },
        dataSourceConfig: {
          text: 'name',
          value: 'id'
        },
        dataSource: this.props.dataSource,
        filter: AutoComplete.nofilter,
        openOnFocus: true
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-1"
      }, /*#__PURE__*/React.createElement(Tooltip, {
        message: "Interest search is case-sensitive.",
        style: {
          color: '#616161'
        }
      })));
    }
  }]);

  return AudienceInterests;
}(Component)) || _class);
export { AudienceInterests as default };
AudienceInterests.defaultProps = {
  specIndex: 0
};